import React from "react";
import styles from "../../styles/HomePage.module.css";

export default function BenefitsSection() {
    return (
        <section className={styles.benefits}>
            <h2 className={styles.sectionTitle}>Train the Way That Works for You</h2>
            <div className={styles.benefitsGrid}>
                <div className={styles.benefit}>
                    <div className={styles.benefitIcon}>🎹</div>
                    <h3 className={styles.benefitTitle}>Practice with Real Sounds</h3>
                    <p className={styles.benefitText}>
                        Piano, guitar, violin - train with the instrument you actually play
                    </p>
                </div>
                <div className={styles.benefit}>
                    <div className={styles.benefitIcon}>⏱️</div>
                    <h3 className={styles.benefitTitle}>Fit Your Schedule</h3>
                    <p className={styles.benefitText}>
                        Quick 2-minute drills or deep 20-minute practice sessions
                    </p>
                </div>
                <div className={styles.benefit}>
                    <div className={styles.benefitIcon}>🎵</div>
                    <h3 className={styles.benefitTitle}>Hear It Your Way</h3>
                    <p className={styles.benefitText}>
                        Notes together (harmonic) or one at a time (melodic) - your choice
                    </p>
                </div>
                <div className={styles.benefit}>
                    <div className={styles.benefitIcon}>📈</div>
                    <h3 className={styles.benefitTitle}>See Your Progress</h3>
                    <p className={styles.benefitText}>
                        Know exactly where you're improving and what needs work
                    </p>
                </div>
                <div className={styles.benefit}>
                    <div className={styles.benefitIcon}>🎯</div>
                    <h3 className={styles.benefitTitle}>Start Where You Are</h3>
                    <p className={styles.benefitText}>
                        Complete beginner or returning musician - customize to your level
                    </p>
                </div>
                <div className={styles.benefit}>
                    <div className={styles.benefitIcon}>🔄</div>
                    <h3 className={styles.benefitTitle}>Practice What You Need</h3>
                    <p className={styles.benefitText}>
                        Focus on your weak spots or challenge yourself with new skills
                    </p>
                </div>
            </div>
        </section>
    );
}
